import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, FormGroup, Tabs, Tab, FormControl, Table, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import FormData from '../formdata';
import EventWidget from "../../components/widgets/event-widget";

import UsersData from '../../components/settings-display-users';
import UsersService from "../../services/users-service";
import FormsService from "../../services/forms-service";
import FormdataService from "../../services/formdata-service";
import './style.css';

class Settings extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            show: false,
            data: null,
            forms: [],
            reports: [],
            branches: [],
            clients:[],
            facilities:[],
            formDataUpdateData: null,
            storedCredenials: UsersService.sharedInstance.getStoredCredentials(),
        }

        this.setForms = this.setForms.bind(this);
        this.getAllFormsByLicense =  this.getAllFormsByLicense.bind(this);
        this.getAllReportsByLicense = this.getAllReportsByLicense.bind(this);
        this.setFormDataUpdateData = this.setFormDataUpdateData.bind(this);
    }

    componentWillMount(){
      this.getAllFormsByLicense();
      // this.getFormDataByType("Branch");
      // this.getFormDataByType("Client");
      // this.getFormDataByType("Facility");
      var stateNames = {"Client": "clients",
                        "Branch": "branches",
                        "Facility": "facilities",
                        "Facility Location": "facilityLocations",
                        "Event": "events",
                        "Call Type": "callTypes",
                        "Incident Type": "incidentTypes",
                        "Skill": "skills",
                        "Auto Email": "autoEmails",
                        "Custom Field 1": "customField1",
                        "Custom Field 2": "customField2",
                        "Custom Field 3": "customField3",
                        "Custom Field 4": "customField4",
                        "Custom Field 5": "customField5"}

      //add getAllReports
    }

    render(){
        return(<div>
                    <Row className="widget-top-container">
                      <Col md={5} style={{backgroundColor: "white"}}>
                        <EventWidget events={this.props.events}/>
                      </Col>
                    </Row>
                    <Row className="main-settings-content">
                        <Col>
                            <div className="settings-header">
                                <h2>Settings</h2>
                            </div>
                            <div className="tab-container">
                                <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                                    <Tab eventKey={1} title="Users" className="leftmost-tab">
                                        <UsersData branches={this.props.branches}/>
                                    </Tab>
                                    <Tab eventKey={2} title="HR Commander">
                                        Tab 2 content
                                    </Tab>
                                    <Tab eventKey={3} title="Form Data">
                                        <FormData forms={this.state.forms}
                                                  setFormDataUpdateData={this.setFormDataUpdateData}
                                                  updateData={this.props.updateData}
                                                  dropDowns={this.state.formData}

                                                  clients={this.props.clients}
                                                  branches={this.props.branches}
                                                  facilities={this.props.facilities}
                                                  facilityLocations={this.props.facilityLocations}
                                                  events={this.props.events}
                                                  callTypes={this.props.callTypes}
                                                  incidentTypes={this.props.incidentTypes}
                                                  skills={this.props.skills}
                                                  autoEmails={this.props.autoEmails}

                                                  customField1={this.props.customField1}
                                                  customField2={this.props.customField2}
                                                  customField3={this.props.customField3}
                                                  customField4={this.props.customField4}
                                                  customField5={this.props.customField5}

                                                  getNameForRecno={this.props.getNameForRecno}
                                                  getRecnoForName={this.props.getRecnoForName}
                                                  />
                                    </Tab>
                                </Tabs>
                            </div>
                        </Col>
                    </Row>
                </div>)
    }

    renderWidgets(){
        return(
            <Row className="dispatch-comm">
                <Col className="" xs={4} md={4} >
                    <div className="card empty-widget">
                        {/* <div className="card-header">
                                <FontAwesomeIcon className="card-header-icon" icon="phone"/>
                                <h5>DISPATCH</h5>
                        </div>

                        <div className="card-content">
                            <Button className="call-dispatch red-btn">CALL DISPATCH</Button>
                        </div> */}
                    </div>
                </Col>
                <Col className="content-section" xs={8} md={8}>
                    <div className="card empty-widget">
                        {/* <div className="card-header">
                            <FontAwesomeIcon className="card-header-icon" icon="comment-alt"/><h5>COMM LOG</h5>
                        </div>
                        <div className="card-content">
                            <form>
                                <FormGroup controlId="formBasicText">
                                <FormControl
                                    type="text"
                                    placeholder="Enter text"
                                />
                                </FormGroup>
                            </form>
                            <Button className="comm-log-btn green-btn">ADD ENTRY</Button>
                        </div> */}
                    </div>
                </Col>
            </Row>
        )
    }

    setForms(forms) {
      this.setState({
        forms: forms,
      })
    }

    getAllFormsByLicense(){
        const storedCredenials = this.state.storedCredenials;
        const loginResponse = storedCredenials.loginResponse;

         var params = {
          "license":loginResponse.data[0].User_License,
          "auth_username":loginResponse.data[0].User_ID,
          "token":loginResponse.token_data.token,
        };

        FormsService.sharedInstance.getAllFormsByLicense(params)
        .then((response)=>{

            this.setState({
                forms: response,
            });

        }).catch((error)=>{
            console.log(error);
        });
    }

    getAllReportsByLicense() {
      //API call here
    }

    setFormDataUpdateData(updateData) {
      this.setState({
        formDataUpdateData: updateData,
      })
    }

}

export default Settings;
